import { useEffect, useState } from "react";
import type { ServerMessage, TribePublic } from "@hoa/protocol";
import { SessionSocket } from "../net.js";
import "../regie/regie.css";

/**
 * L'écran collectif d'une tribu (16:9, vidéoprojecteur ou écran du bar),
 * redessiné dans le langage de la projection d'événement. Il ne reçoit que
 * des agrégats : jamais de position, de message, de réponse ni de pseudo.
 */
export function Collectif(props: { sessionId: string }): JSX.Element {
  const [participants, setParticipants] = useState(0);
  const [tribes, setTribes] = useState<TribePublic[]>([]);
  const [connecte, setConnecte] = useState(false);
  const [dernier, setDernier] = useState<{ text: string; gom?: string } | null>(null);

  useEffect(() => {
    document.title = "Hoa · écran collectif";
    if (!props.sessionId) return;
    const s = new SessionSocket(
      props.sessionId,
      {
        onOpen: () => setConnecte(true),
        onClose: () => setConnecte(false),
        onMessage: (msg: ServerMessage) => {
          if (msg.type === "collective") {
            setParticipants(msg.participants);
            setTribes(msg.tribes);
          }
          if (msg.type === "event") setDernier({ text: msg.text, gom: msg.gom });
        },
      },
      null,
      "collective",
    );
    s.connect();
    return () => s.close();
  }, [props.sessionId]);

  if (!props.sessionId) {
    return (
      <div className="rg-projection" style={{ justifyContent: "center", alignItems: "center" }}>
        <span className="sous">Ouvrez cette page depuis la régie.</span>
      </div>
    );
  }

  return (
    <div className="rg-projection">
      <div>
        <h1>{tribes.length === 1 ? tribes[0]!.title : "Les tribus de ce soir"}</h1>
        <div className="sous">
          {participants} {participants > 1 ? "humains" : "humain"} · {connecte ? "en direct" : "reconnexion…"}
        </div>
      </div>
      {dernier ? <div style={{ fontSize: "4vh", fontWeight: 700 }}>{dernier.gom ?? dernier.text}</div> : null}
      <div className="tables">
        {tribes.map((t) => (
          <div className="table" key={t.themeId}>
            <i style={{ background: t.color }} />
            <div style={{ minWidth: 0 }}>
              <b>Tribu {t.tribeName}</b>
              <small>
                {t.gathered
                  ? "réunie"
                  : t.formed
                    ? "en route vers le rendez-vous"
                    : `${t.present} sur ${t.threshold}${t.present < t.threshold ? ` · il en manque ${t.threshold - t.present}` : ""}`}
              </small>
            </div>
          </div>
        ))}
      </div>
      <div className="pied">
        <span style={{ color: "#B5B5B5" }}>Aucune position, aucun message, aucun pseudo n'apparaît ici.</span>
      </div>
    </div>
  );
}
